import React from 'react';
import {Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {useAppointmentNotifications} from 'presentation/pages/private/hooks';
import {AppointmentsD0Props} from './types';

const {appointmentsNotifications} = translations['pt-br'].privateFlow.home;

export function AppointmentsD0({appointment}: AppointmentsD0Props) {
	const {formattedBeneficiary, formattedDate, isExam, isSurgery} = useAppointmentNotifications({
		appointment,
	});

	const customPart1 = () => {
		if (isExam) {
			return appointmentsNotifications.yourExamAppointment;
		}
		if (isSurgery) {
			return appointmentsNotifications.yourSurgeryAppointment;
		}
		return appointmentsNotifications.nextAppointment;
	};

	const part1 = `${formattedBeneficiary}, ${customPart1()} `;
	const highlighted = `${appointmentsNotifications.isTodayAt} ${formattedDate}.`;

	return (
		<Stack spacing={1}>
			<Typography>
				{part1}
				<Typography component="strong" fontWeight={700}>
					{highlighted}
				</Typography>
			</Typography>
		</Stack>
	);
}
